import React from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import { useOnDismissDialog } from '../../../analytics/use-on-dismiss-dialog';
import { PopupEntryPoint } from '../shared/popup-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';

export function PaymentDetailsPopupDialog() {
	const onClose = useOnDismissDialog({ ...DIALOG_CONFIG });

	return (
		<AnalyticsContext data={DIALOG_CONFIG}>
			<PopupEntryPoint entryPoint={entryPoint} placement={'bottom-start'} onClose={onClose} />
		</AnalyticsContext>
	);
}
